<template>
  <div class="yhc-component YhcCheckTime" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <el-date-picker
        class="range0"
        :editable="false"
        type="date"
        v-model="searchEpochFrom"
        @change="changeTime"
      ></el-date-picker>
      <span class="yhc-fzc-black split range1">-</span>
      <el-date-picker
        class="range2"
        :editable="false"
        type="date"
        v-model="searchEpochTo"
        @change="changeTime"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';

let identifierName = 'YhcCheckTime';
export default {
  name: identifierName,
  components: { PrivateLabel },
  data() {
    return {
      searchEpochFrom: null,
      searchEpochTo: null,
    };
  },
  mixins: [propsMixin],
  props: {
    // 时间默认值，通常传入pageList的epochFrom和epochTo即可，就是时间戳
    epochFrom: {
      type: Number,
    },
    epochTo: {
      type: Number,
    },
  },
  created() {},
  mounted() {
    if (this.epochFrom) {
      this.searchEpochFrom = this.epochFrom;
    }
    if (this.epochFrom == 0) {
      // 其实为0也是需要显示的
      // 但是这里elementUI会默认过滤了
      // 而且js语言判断0也是个悲剧
      this.searchEpochFrom = 1;
    }
    if (this.epochTo) {
      this.searchEpochTo = this.epochTo;
    }
  },
  methods: {
    changeTime() {
      var epochForm = this.searchEpochFrom ? new Date(this.searchEpochFrom).getTime() : null;
      var epochTo = this.searchEpochTo ? new Date(this.searchEpochTo).getTime() : null;
      this.$emit('time', [epochForm, epochTo]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcCheckTime {
  @include labelCommon();

  // 这里的content会和@include进来的那个同时存在的，不过优先级是这里，如果不行的话就用!important
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .split {
    margin: 0 8px;
  }

  .range0,
  .range2 {
    flex: 4;
    width: auto;
  }
  .range1 {
    flex: 1;
    text-align: center;
  }
}
</style>
